<!--  DEALER HEADER  -->

<ui-dealer-header [location]="'engage_configure'"></ui-dealer-header>

<!--  END DEALER HEADER  -->

<!--  COOKIE POLICY CONTENT  -->

<div class="written-content padded">
	<h3>COOKIE POLICY</h3>
	<p>
		To make this site work properly, we sometimes place small data files called cookies on your device. Most big
		websites do this too.
	</p>

	<h4>What are cookies?</h4>
	<p>
		A cookie is a small text file that a website saves on your computer or mobile device when you visit the site. It
		enables the website to remember your actions and preferences (such as login, language, font size and other
		display preferences) over a period of time, so you don’t have to keep re-entering them whenever you come back to
		the site or browse from one page to another.
	</p>

	<h4>How do we use cookies?</h4>
	<p>A number of our pages use cookies to:</p>
	<ul>
		<li>
			<strong>Protect your privacy.</strong>
			We use cookies to make sure that only authenticated devices are allowed to view your data. We do this by
			storing a token that is unique to you on your device. This token will only be present if you have authorised
			the device, either by following a link in an email / SMS, or by entering your details directly into the
			site.
		</li>
		<li>
			<strong>Enhance website performance.</strong>
			We use cookies to ensure our websites run smoothly and perform efficiently. These cookies do not contain
			personal information.
		</li>
	</ul>
	<p>
		Enabling these cookies is required for the use of this service. Without these cookies we are unable to provide
		full website functionality.
	</p>

	<h4>Third-party cookies</h4>
	<p>
		In addition to our own cookies, we may also use various cookies from third-parties to report anonymous usage
		statistics and/or provide functionality enhancements.
	</p>

	<h4>How to control cookies</h4>
	<p>
		You can control and/or delete cookies as you wish – for details, see
		<a href="aboutcookies.org" target="_blank" class="text-hl">aboutcookies.org</a>
		. You can delete all cookies that are already on your computer and you can set most browsers to prevent them
		from being placed. If you do this, however, you may have to manually adjust some preferences every time you
		visit a site and some services and functionality may not work.
	</p>

	<ng-template [ngIf]="dealer.cookie_policy_url">
		<h4 id="additional">Additional Cookie Policy</h4>
		<p>
			By agreeing to this Cookie Policy you also agree to the
			<a class="text-hl" [href]="dealer.cookie_policy_url" target="_blank">Cookie Policy found here</a>
			.
		</p>
	</ng-template>
</div>

<!-- END COOKIE POLICY CONTENT  -->

<!--  FOOTER LINKS  -->

<cng-legal-footer-links></cng-legal-footer-links>

<!-- END FOOTER LINKS  -->

<!--  SCROLL FADES  -->

<div class="scroll-fade top"></div>

<!--  END SCROLL FADES  -->
